import styled from 'styled-components';

import { getColor, getColorFromTheme } from '@utils/theme';

import { ColorTypes, FontSizeTypes, TintTypes } from '@folx-types/theme';

import theme from '@theme/WsTheme';

type IBodyTextProps = {
	size?: FontSizeTypes;
	color?: ColorTypes;
	tint?: TintTypes;
	type?: 'normal' | 'bold';
	uppercase?: boolean;
};

export default styled.p<IBodyTextProps>`
	color: ${({ theme: components, color, tint }) =>
		color
			? getColor(color, tint)
			: getColorFromTheme(components.bodyText.color, components.bodyText.tint)};
	font-size: ${({ size }) => theme.fontSizes.body[size || 'md']};
	line-height: ${({ size }) => theme.lineHeights.body[size || 'md']};
	${({ uppercase = false }) => uppercase && 'text-transform: uppercase;'}
	font-family: ${({ type }) =>
		type === 'bold' ? 'Chalet-NewYorkSixty, sans-serif' : 'Chalet-LondonSixty, sans-serif'};
	font-family: ${({ size }) => size === 'label' && 'Montserrat'};
`;
